export const PRIVACY = {
  title: "Privacy Policy",
  updated: "[Tanggal berlaku]",
  body: `Kebijakan Privasi ini menjelaskan bagaimana BagiPulsa ("kami") mengumpulkan, menggunakan, dan melindungi data pribadi pengguna website bagipulsa.id dan aplikasi BagiPulsa.

## 1. Data yang kami kumpulkan
Nama, nomor telepon, alamat email, nomor rekening bank atau akun eWallet tujuan pencairan, nomor pengirim pulsa, serta riwayat transaksi. Kami juga dapat mengumpulkan data teknis seperti jenis perangkat dan alamat IP.

## 2. Penggunaan data
Data digunakan untuk memproses transaksi convert pulsa, mencairkan dana ke rekening atau eWallet tujuan, memverifikasi bahwa pulsa berasal dari sumber yang legal, memberikan layanan pelanggan, dan meningkatkan layanan kami.

## 3. Pembagian data
Kami tidak menjual data pribadi pengguna. Data hanya dibagikan kepada pihak yang diperlukan untuk menyelesaikan transaksi (misalnya bank atau penyedia eWallet) atau jika diwajibkan oleh hukum dan aparat penegak hukum yang berwenang.

## 4. Keamanan data
Kami menerapkan langkah keamanan yang wajar untuk melindungi data dari akses, perubahan, atau pengungkapan yang tidak sah.

## 5. Penyimpanan data
Data disimpan selama akun aktif atau selama diperlukan untuk keperluan transaksi, hukum, dan pencegahan penipuan.

## 6. Hak pengguna
Pengguna dapat meminta akses, perbaikan, atau penghapusan data pribadinya dengan menghubungi layanan pelanggan kami.

## 7. Perubahan kebijakan
Kebijakan ini dapat diperbarui sewaktu-waktu. Perubahan akan diumumkan di halaman ini.

## 8. Kontak
Pertanyaan mengenai kebijakan privasi dapat dikirim ke [Email CS] atau WhatsApp [Nomor WhatsApp CS]. [Nama badan usaha], [Alamat].`,
};

export const TERMS = {
  title: "Terms and Conditions",
  updated: "[Tanggal berlaku]",
  body: `Dengan menggunakan website dan aplikasi BagiPulsa, kamu menyetujui Syarat dan Ketentuan berikut.

## 1. Layanan
BagiPulsa menyediakan jasa convert (tukar) pulsa menjadi uang yang dicairkan ke rekening bank atau eWallet milik pengguna.

## 2. Pulsa yang diterima
Kami hanya menerima pulsa yang legal dan berasal dari sumber yang jelas. Kami tidak menerima pulsa hasil penipuan, cloning SIM, judi online, hasil bug operator, atau sumber ilegal lainnya. Transaksi yang terindikasi ilegal akan ditolak dan dapat dilaporkan kepada pihak berwenang.

## 3. Rate dan pencairan
Rate convert ditampilkan di website dan aplikasi, dan dapat berubah setiap hari. Rate yang berlaku adalah rate pada saat transaksi dibuat. Pencairan tidak dikenakan biaya admin.

## 4. Kewajiban pengguna
Pengguna wajib memasukkan data tujuan pencairan dengan benar dan mengirim pulsa sesuai instruksi. Kesalahan input data oleh pengguna di luar tanggung jawab kami.

## 5. Waktu proses
Transaksi umumnya diproses dalam 1–10 menit. Keterlambatan dapat terjadi karena gangguan operator, bank, atau eWallet.

## 6. Pembatalan dan pengembalian
Pulsa yang sudah dikirim dan berhasil diverifikasi tidak dapat dibatalkan. Ketentuan pengembalian untuk transaksi gagal: [Kebijakan refund].

## 7. Batasan tanggung jawab
BagiPulsa tidak bertanggung jawab atas kerugian akibat penyalahgunaan akun oleh pihak lain atau kesalahan data dari pengguna.

## 8. Perubahan ketentuan
Syarat dan Ketentuan ini dapat diperbarui sewaktu-waktu. Penggunaan layanan setelah perubahan berarti kamu menyetujui ketentuan yang baru.

## 9. Kontak
[Nama badan usaha], [Alamat]. Email: [Email CS]. WhatsApp: [Nomor WhatsApp CS].`,
};
